/*  ================================================================================
    SLIDER COMPONENT
    ================================================================================  */

class SliderComponent extends HTMLElement {

    constructor () {
  
      super()
      this.slider     = this.querySelector('.slider-container');
      this.sliderItems = this.querySelectorAll('.slide');
      this.prevButton = this.querySelector('.slider-prev');
      this.nextButton = this.querySelector('.slider-next');
      this.pagination = this.querySelector('.slider-pagination');
  
      this.isDragging       = false;
      this.startPosition    = 0;
      this.startScrollLeft  = 0;
    
      if (!this.slider) return;
  
      const resizeObserver = new ResizeObserver(entries => this.initPages());
            resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.updateNavigation.bind(this));
  
      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      };
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      }
  
      this.initPages()
  
    }
  
    initPages () {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0); 
      if (this.sliderItemsToShow.length <= 1) return; // if there is only one child then exit;
      this.sliderItemWidth = this.sliderItemsToShow[0].getBoundingClientRect().width;
      this.slidesPerPage = Math.floor(this.slider.getBoundingClientRect().width / this.sliderItemWidth);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.createBullets();
      this.updateNavigation();
    }
  
  
    createBullets () {
      this.pagination.innerHTML = '';
      if (this.totalPages > 1) {
        for (let i = 0; i < this.totalPages; i++) {
          const bullet = document.createElement('span');
                bullet.classList.add('slider-bullet');
                bullet.addEventListener('click', () => {
                  this.setActiveSlide(i);
                });
          this.pagination.appendChild(bullet);
        }
      }
    }
    
  
    updateNavigation () {
  
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemWidth) + 1;
  
      if (this.prevButton) {
        this.prevButton.removeAttribute('disabled');
        if (this.currentPage == 1 ||  this.sliderItemsToShow.length < this.slidesPerPage) this.prevButton.setAttribute('disabled', 'disabled');
      }
      if (this.nextButton) {
        this.nextButton.removeAttribute('disabled');
        if (this.currentPage == this.totalPages || this.sliderItemsToShow.length < this.slidesPerPage) this.nextButton.setAttribute('disabled', 'disabled');
      }
  
      if (this.sliderItemsToShow.length < this.slidesPerPage || this.totalPages == 1) {
        this.prevButton.style.visibility = 'hidden';
        this.nextButton.style.visibility = 'hidden';
      }
  
      for (let i = 0; i < this.pagination.children.length; i++) {
        this.pagination.children[i].classList.remove('active');
      }
      if (this.pagination && this.pagination.children.length > 0) {
        var index = this.currentPage - 1; // Calculate index
        if (index >= 0 && index < this.pagination.children.length) {
            this.pagination.children[index].classList.add("active");
        } 
      }
  
    }
  
    setActiveSlide (page) {
      this.slideScrollPosition = page * this.sliderItemWidth;
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
    onButtonClick (event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemWidth) : this.slider.scrollLeft - (step * this.sliderItemWidth)
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
  
    
  
    
  }
  
  customElements.define('slider-component', SliderComponent)


/*  ================================================================================
    ZOOM BACK IMAGE
    ================================================================================  */


  class ZoomBackImage extends HTMLElement {

    constructor () {
  
      super();
      this.attachShadow({ mode: 'open' });
      this.shadowRoot.innerHTML = `
        <style>
          
          :host {
            overflow:clip;
            display: block;
            position:relative;
            aspect-ratio: 1/1;
          }
        </style>
        <slot></slot>
      `;
  
      this.image     = this.querySelector('img');
  
      this.image.style.position        = "relative";
      this.image.style.transform       = "matrix(1.4, 0, 0, 1.4, 0, 0)";
      this.image.style.transformOrigin = "center top;";
      this.image.style.objectFit       = "cover";
  
      this.elementY          = this.getBoundingClientRect().top + window.scrollY;
      this.elementHeight     = this.offsetHeight;
      this.windowHeight      = window.innerHeight;
  
      this.triggerTopBottom    = this.elementY - this.windowHeight;
      this.triggerBottomTop    = this.elementY + this.elementHeight;
  
      this.update();
  
    }
  
    update() {
  
      const scrollTop    = window.scrollY;
  
      const animateRange = this.triggerBottomTop - this.triggerTopBottom;
      const startPos     = Math.min(Math.max(0, scrollTop - this.triggerTopBottom),animateRange);
      const progress     = startPos/animateRange;
      const scale       = 1.4 - (progress*0.4);
  
      if (this.image) {
        this.image.style.transform = `matrix(${scale}, 0, 0, ${scale}, 0, 0)`;
      }
      requestAnimationFrame(() => this.update());
    }
  
    
  }
  
  
  customElements.define('zoom-back-image', ZoomBackImage);
  


/*  ================================================================================
    PARALLAX IMAGE
    ================================================================================  */


  class ParallaxImage extends HTMLElement {

    constructor () {
  
      super();
      this.attachShadow({ mode: 'open' });
      this.shadowRoot.innerHTML = `
        <style>
          
          :host {
            overflow:clip;
            display: block;
            position:relative;
            aspect-ratio: 1/1;
          }
        </style>
        <slot></slot>
      `;
  
      this.image     = this.querySelector('img');
  
      this.image.style.position    = "relative";
      this.image.style.transform   = "scale(1.2)";
      this.image.style.top         = "-10%";
      this.image.style.objectFit   = "cover";
  
      this.elementY          = this.getBoundingClientRect().top + window.scrollY;
      this.elementHeight     = this.offsetHeight;
      this.windowHeight      = window.innerHeight;
  
      this.triggerTopBottom    = this.elementY - this.windowHeight;
      this.triggerBottomTop    = this.elementY + this.elementHeight;
  
      this.updatePosition();
  
    }
  
    updatePosition() {
  
      const scrollTop    = window.scrollY;
  
      const animateRange = this.triggerBottomTop - this.triggerTopBottom;
      const startPos     = Math.min(Math.max(0, scrollTop - this.triggerTopBottom),animateRange);
      const progress     = startPos/animateRange;
      const percentage   = progress*20;
  
      if (this.image) {
        this.image.style.top = `${percentage}%`;
      }
      requestAnimationFrame(() => this.updatePosition());
    }
  
    
  }
  
  customElements.define('parallax-image', ParallaxImage);





  class CompareSlider extends HTMLElement {

  constructor () {

    super();

    this.sliding = false;

    this.compareSlider            = this.querySelector('.compare-slider');
    this.compareSliderReveal      = this.querySelector(".compare-slider__reveal");
    this.compareSliderController  = this.querySelector(".compare-slider__controller");

    this.compareSlider.addEventListener("mousedown",this.onCompareMouseDown.bind(this));
    this.compareSlider.addEventListener("mouseup",this.onCompareMouseUp.bind(this));
    this.compareSlider.addEventListener("mousemove",this.onCompareMouseMove.bind(this));

    this.compareSlider.addEventListener("touchstart", this.onCompareMouseDown.bind(this), { passive: true });
    this.compareSlider.addEventListener("touchend", this.onCompareMouseUp.bind(this), { passive: true });
    this.compareSlider.addEventListener("touchmove", this.onCompareMouseMove.bind(this), { passive: true });

  }


  onCompareMouseUp(event) {
    this.sliding = false;
  }
  onCompareMouseDown(event) {
    this.sliding = true;
  }
  onCompareMouseMove(event) {

   if (this.sliding) {

      var element = this.compareSlider; // Use the slider container instead of event target
      var rect = element.getBoundingClientRect(); // Get the position of the element relative to the viewport
      var posX = event.clientX - rect.left;

      if (!posX) {
        posX= event.touches[0].pageX  - rect.left;
      }

      if (posX>5) {

        var sliderWidth =  this.compareSlider.offsetWidth;
        var percWidth = Math.floor((posX / sliderWidth) * 100);
      
        if (percWidth < 5) percWidth = 5;
        if (percWidth > 95) percWidth = 95;
      
        this.compareSliderReveal.style.clipPath = 'polygon(' + percWidth + '% 0%, 100% 0%, 100% 100%, ' + percWidth + '% 100%)';
        this.compareSliderController.style.left = percWidth + '%';

      }
      
    }
      

  }


  
}

customElements.define('compare-slider', CompareSlider)